// src/components/PartnersSlider/PartnersSlider.jsx
import React, { useState, useEffect } from 'react';
import './css/PartnersSlider.css';

// === Импортируем все логотипы из твоей папки ===
import rostelecom from '../../img/partner/rostelecom.png';
import zvezda from '../../img/partner/zvezda.png';
import martlet from '../../img/partner/martlet.png';
import MTC from '../../img/partner/MTC.jpg';

// === Импортируем флаги стран ===
import ruFlag from '../../img/flags/ru.png';
import byFlag from '../../img/flags/by.png';

const partners = [
  { id: 1, name: 'Ростелеком', logo: rostelecom, country: 'RU' },
  { id: 2, name: 'МТС', logo: MTC, country: 'RU' },
  { id: 3, name: 'Martlet', logo: martlet, country: 'BY' },
  { id: 4, name: 'Zvezda', logo: zvezda, country: 'RU' },
  
];

const PartnersSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setItemsPerPage(1);
        setSlidesToShow(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
        setSlidesToShow(2);
      } else {
        setItemsPerPage(4);
        setSlidesToShow(4);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Вычисляем общее количество слайдов
  const totalSlides = Math.ceil(partners.length / slidesToShow);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const showControls = partners.length > slidesToShow;

  // Вычисляем смещение для трансформации
  const getTransformValue = () => {
    if (slidesToShow >= partners.length) {
      return 0;
    }
    return -(currentIndex * (100 / slidesToShow)) * slidesToShow; 
  };

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="h2-background">
          <h2 className="partners-title">Наши партнёры</h2>
        </div>

        <div className="partners-slider-wrapper">
          {showControls && (
            <>
              <button className="partners-arrow partners-arrow--left" onClick={prevSlide}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M30 34L18 24L30 14" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </button>

              <button className="partners-arrow partners-arrow--right" onClick={nextSlide}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M18 14L30 24L18 34" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </button>
            </>
          )}

          <div className="partners-slider">
            <div
              className="partners-track"
              style={{
                transform: `translateX(${getTransformValue()}%)`,
              }}
            >
              {partners.map((partner) => (
                <div 
                  key={partner.id} 
                  className="partners-slide"
                  style={{
                    flex: `0 0 ${100 / itemsPerPage}%`,
                    maxWidth: `${100 / itemsPerPage}%`
                  }}
                >
                  <div className="partner-card">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="partners-logo"
                    />
                    <img
                      src={partner.country === 'RU' ? ruFlag : byFlag}
                      alt={`${partner.country} flag`}
                      className="country-flag"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {showControls && totalSlides > 1 && (
          <div className="partners-dots">
            {Array(totalSlides)
              .fill(null)
              .map((_, idx) => (
                <span
                  key={idx}
                  className={`partners-dot ${
                    idx === currentIndex ? 'active' : ''
                  }`}
                  onClick={() => goToSlide(idx)}
                />
              ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnersSlider;